import React from 'react';
import { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  Typography,
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import { appConfig } from '../../../../config/app';
import { CustomEvents } from '../../../../constants/analytics.constant';

const ID_NUMBER = 'Identification number has already been taken';
const ID_NUMBER_SPA =
  'Número de identificación Número de identificación ya en uso!';
const INVALID_PHONE = 'Phone is invalid';
const INVALID_DATA = 'invalid-data';
const DECLARE_LICENSE_PLATE = 'declare-license-plate';
const EXISTING_USER = 'existing-user';
const INVALID_USER = 'invalid-user';
const SURA_TAKEN = 'Sura global login has already been taken';
const ERROR_FETCHING = 'Error while fetching data from Sura.';
const ID_NUMBER_SURA_TAKEN =
  'Identification number has already been taken and Sura global login has already been taken';
const VALIDATION_DATE_INVALID =
  'Validation failed: Date invalid: you are not insured for the given date';
const INVALID_COMPANY = 'not_company';
const INVALID_CREDENTIALS = 'Invalid authentication credentials';
const TRY_MANUALLY_LOGIN = 'try_manually_login';
const EMAIL_SPA = 'Email Email ya en uso!';
const REGISTER_FAILURE = 'register_failure';
const AFFINITY_USER = 'affinity_user';
const INVALID_AUTH_ANSWER = 'invalid_auth_answer';

const logAnalytics = async (logEvent) => {
  await logEvent(CustomEvents.OPEN_WHATSAPP, {
    app: appConfig?.NAME,
  });
};

export const getContentForDialog = (
  error: string,
  onClose: () => void,
  logEvent: Function
) => {
  switch (error) {
    case ID_NUMBER:
    case ID_NUMBER_SPA:
      return {
        title: <>Ya existe un usuario registrado con ese documento</>,
        content: (
          <>
            Ya existe un usuario registrado con ese documento. Por favor ingresá
            con tus datos o recuperá tu contraseña.
          </>
        ),
        action: (
          <Button component={RouterLink} to="/login" color="primary">
            Entendido
          </Button>
        ),
      };

    case EMAIL_SPA:
      return {
        title: <>Ya existe un usuario registrado con ese email</>,
        content: (
          <>
            Ya existe un usuario registrado con ese email. Por favor ingresá con
            tus datos o recuperá tu contraseña.
          </>
        ),
        action: (
          <Button component={RouterLink} to="/login" color="primary">
            Entendido
          </Button>
        ),
      };

    case INVALID_PHONE:
      return {
        title: (
          <Typography variant="h6" component="span">
            Los datos telefónicos ingresados no son correctos
          </Typography>
        ),
        content: (
          <>
            Por favor revisalos y volvé a intentarlo.
            <br />
            <br />
            Si esto es un error, por favor comunicate con nosotros por Whatsapp
            al siguiente número:{' '}
            <Link
              color="secondary"
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
              onClick={() => logAnalytics(logEvent)}
            >
              {appConfig?.FORMATED_WHATSAPP}
            </Link>
          </>
        ),
        action: (
          <Button onClick={onClose} color="primary">
            Entendido
          </Button>
        ),
      };

    case INVALID_DATA:
      return {
        title: (
          <Typography variant="h6" component="span">
            Los datos ingresados no son correctos
          </Typography>
        ),
        content: (
          <>
            Por favor revisalos y volvé a intentarlo.
            <br />
            <br />
            Si esto es un error, por favor comunicate con nosotros por Whatsapp
            al siguiente número:{' '}
            <Link
              color="secondary"
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
              onClick={() => logAnalytics(logEvent)}
            >
              {appConfig?.FORMATED_WHATSAPP}
            </Link>
          </>
        ),
        action: (
          <Button onClick={onClose} color="primary">
            Entendido
          </Button>
        ),
      };

    case DECLARE_LICENSE_PLATE:
      return {
        title: <>¡Atención!</>,
        content: (
          <>
            Para poder ingresar necesitamos que declares tu patente en la
            compañía. Podés hacerlo por Whatsapp al siguiente número:{' '}
            <Link
              color="secondary"
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
              onClick={() => logAnalytics(logEvent)}
            >
              {appConfig?.FORMATED_WHATSAPP}
            </Link>
          </>
        ),
        action: (
          <Button onClick={onClose} color="primary">
            Entendido
          </Button>
        ),
      };

    case EXISTING_USER:
      return {
        title: <>Ya existe un usuario registrado con ese documento</>,
        content: <>Por favor ingresá con tus datos o recuperá tu contraseña.</>,
        action: (
          <Button
            component={RouterLink}
            onClick={onClose}
            color="primary"
            to="/login"
          >
            Entendido
          </Button>
        ),
      };

    case INVALID_USER:
      return {
        title: <>Los datos ingresados no son correctos</>,
        content: (
          <>
            Por favor revisalos y volvé a intentarlo.
            <br />
            <br />
            Si esto es un error, por favor comunicate con nosotros por Whatsapp
            al siguiente número:{' '}
            <Link
              color="secondary"
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
              onClick={() => logAnalytics(logEvent)}
            >
              {appConfig?.FORMATED_WHATSAPP}
            </Link>
          </>
        ),
        action: (
          <Button onClick={onClose} color="primary">
            Entendido
          </Button>
        ),
      };

    case SURA_TAKEN:
      return {
        title: <>Ha ocurrido un error en la validación</>,
        content: <>Por favor volvé a intentarlo.</>,
        action: (
          <Button onClick={onClose} color="primary">
            Entendido
          </Button>
        ),
      };

    case ERROR_FETCHING:
      return {
        title: <>¡Lo sentimos!</>,
        content: (
          <>
            Ocurrió un error que debemos revisar. Te dejamos los teléfonos
            disponibles por cada gestión disponible:
            <br />
            <Box component="ul">
              <Typography component="li">
                Whatsapp:{' '}
                <Link
                  color="secondary"
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                  onClick={() => logAnalytics(logEvent)}
                >
                  {appConfig?.FORMATED_WHATSAPP}
                </Link>
              </Typography>
            </Box>
          </>
        ),
        action: (
          <Button component={RouterLink} to="/login" color="primary">
            Entendido
          </Button>
        ),
      };

    case ID_NUMBER_SURA_TAKEN:
      return {
        title: <>Ha ocurrido un error en la validación</>,
        content: <>Por favor volvé a intentarlo nuevamente.</>,
        action: (
          <Button color="primary" onClick={onClose}>
            Entendido
          </Button>
        ),
      };

    case VALIDATION_DATE_INVALID:
      return {
        title: <>¡Lo sentimos!</>,
        content: (
          <>
            Esta denuncia no puede procesarse por Autogestión.
            <br />
            <br />
            Por favor comunicate con nosotros por Whatsapp al{' '}
            <Link
              color="secondary"
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
              onClick={() => logAnalytics(logEvent)}
            >
              {appConfig?.FORMATED_WHATSAPP}
            </Link>{' '}
            para cargar tu denuncia.
          </>
        ),
        action: (
          <Button color="primary" onClick={onClose}>
            Entendido
          </Button>
        ),
      };

    case INVALID_COMPANY:
      return {
        title: <></>,
        content: (
          <Box>
            {appConfig?.NAME === 'Seguros Sura' && (
              <Typography display="inline" variant="h6" component="span">
                Detectamos que posees tu póliza a través de answer Seguros{' '}
              </Typography>
            )}
            {appConfig?.NAME === 'Answer Seguros' && (
              <Typography display="inline" variant="h6" component="span">
                Detectamos que posees tu póliza a través de Galicia{' '}
              </Typography>
            )}
            <Typography display="inline">
              Accedé a tu información, ingresando a{' '}
            </Typography>
            <Link href={appConfig?.ALTERNATIVE_WEBSITE}>
              <Typography display="inline" component="span" color="primary">
                {appConfig?.ALTERNATIVE_POLICIES}
              </Typography>
            </Link>
          </Box>
        ),
        action: (
          <Grid container justify="center">
            <Grid item>
              <Button onClick={onClose} variant="contained" color="primary">
                Cerrar
              </Button>
            </Grid>
          </Grid>
        ),
      };

    case INVALID_CREDENTIALS:
      return {
        title: <>¡Lo sentimos!</>,
        content: (
          <>
            Detectamos un error en el usuario o la contraseña ingresados, por
            favor revisa los datos e intenta nuevamente.
          </>
        ),
        action: (
          <Button color="primary" onClick={onClose}>
            Entendido
          </Button>
        ),
      };

    case TRY_MANUALLY_LOGIN:
      return {
        title: <>¡Registro exitoso!</>,
        content: (
          <>
            Tu solicitud de registro se procesó correctamente pero no pudimos
            iniciar tu sesión automáticamente, por favor iniciá sesión de forma
            manual.
          </>
        ),
        action: (
          <Button color="primary" onClick={onClose}>
            Ir al sitio de inicio de sesión
          </Button>
        ),
      };

    case REGISTER_FAILURE:
      return {
        title: <>¡Lo sentimos!</>,
        content: (
          <>
            <Typography component="span">
              No pudimos completar tu registro. Te dejamos los teléfonos
              disponibles para cada gestión:
            </Typography>
            <List component="span">
              <ListItem>
                <Box mr={1} mb={0} component="span">
                  <FiberManualRecordIcon style={{ width: 15, height: 15 }} />
                </Box>
                <Box mr={1} mt={1} component="span">
                  <Typography display="block" component="span">
                    Para resolver el problema de registro hablemos por Whatsapp
                    al <br />
                    <Link
                      color="secondary"
                      href={appConfig?.WHATSAPP_LINK}
                      rel="noopener"
                      target="_blank"
                      onClick={() => logAnalytics(logEvent)}
                    >
                      {appConfig?.FORMATED_WHATSAPP}
                    </Link>{' '}
                  </Typography>
                </Box>
              </ListItem>

              <ListItem>
                <Box mr={1} mb={0} component="span">
                  <FiberManualRecordIcon style={{ width: 15, height: 15 }} />
                </Box>
                <Box mr={1} mt={1} component="span">
                  <Typography display="block" component="span">
                    Para reportar un choque, robo o daño hablemos por Whatsapp
                    al <br />
                    <Link
                      color="secondary"
                      href={appConfig?.WHATSAPP_LINK}
                      rel="noopener"
                      target="_blank"
                      onClick={() => logAnalytics(logEvent)}
                    >
                      {appConfig?.FORMATED_WHATSAPP}
                    </Link>{' '}
                    o llamanos al{' '}
                    <Link
                      color="secondary"
                      href={appConfig?.CONTACT_PHONE}
                      rel="noopener"
                      target="_blank"
                      onClick={() => logAnalytics(logEvent)}
                    >
                      {appConfig?.FORMATED_CONTACT_PHONE}
                    </Link>{' '}
                  </Typography>
                </Box>
              </ListItem>
              <ListItem>
                <Box mr={1} mb={0} component="span">
                  <FiberManualRecordIcon style={{ width: 15, height: 15 }} />
                </Box>
                <Box mr={1} mt={1} component="span">
                  <Typography display="block" component="span">
                    Para solicitar una asistencia mecánica comunicate al{' '}
                    <Link
                      color="secondary"
                      href={appConfig?.ASSISTANCE_PHONE}
                      rel="noopener"
                      target="_blank"
                      onClick={() => logAnalytics(logEvent)}
                    >
                      {appConfig?.FORMATED_ASSISTANCE_PHONE}
                    </Link>{' '}
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </>
        ),
        action: (
          <Button color="primary" onClick={onClose}>
            Entendido
          </Button>
        ),
      };

    case AFFINITY_USER:
      return {
        title: <>Nuestra App no se encuentra disponible</>,
        content: (
          <>
            <div>
              {' '}
              Contactanos por WhatsApp al 11 2808 0330 o por teléfono al 0800
              222 2772 de lunes a viernes de 9 a 19 h.{' '}
            </div>
            <div> ¡Gracias por ser parte de nuestra comunidad! 🤝 </div>
          </>
        ),
        action: (
          <Button color="primary" onClick={onClose}>
            {' '}
            Entendido{' '}
          </Button>
        ),
      };

    case INVALID_AUTH_ANSWER:
      return {
        title: <>¡Error al iniciar tu sesión!</>,
        content: (
          <>
            <div>
              Usuario o contraseña incorrectos, por favor revisa los datos
              ingresados y volvé a intentarlo. Si el problema continúa,
              contactanos de lunes a viernes de 9 a 18h a alguna de las
              siguientes opciones:
            </div>
            <div>
              Whatsapp:{' '}
              <Link
                color="secondary"
                href={appConfig?.WHATSAPP_LINK}
                rel="noopener"
                target="_blank"
              >
                {appConfig?.FORMATED_WHATSAPP}
              </Link>
              ,
            </div>
            <div>
              Central telefónica:{' '}
              <Link
                color="secondary"
                href={appConfig?.FORMATED_CONTACT_PHONE}
                rel="noopener"
                target="_blank"
              >
                {appConfig.FORMATED_CONTACT_PHONE}
              </Link>
              ,
            </div>
            <div>
              Servicio de Grúa y emergencias:{' '}
              <Link
                color="secondary"
                href={appConfig?.FORMATED_ASSISTANCE_PHONE}
                rel="noopener"
                target="_blank"
              >
                {appConfig.FORMATED_ASSISTANCE_PHONE}
              </Link>
            </div>
          </>
        ),
        action: (
          <Grid container justify="center">
            <Grid item>
              <Button onClick={onClose} variant="contained" color="primary">
                Entendido
              </Button>
            </Grid>
          </Grid>
        ),
      };

    default:
      return {
        title:
          process.env.REACT_APP_WEBSITE === 'SURA' ? (
            <>¡Lo sentimos!</>
          ) : (
            <>¡Error al iniciar tu sesión!</>
          ),
        content:
          process.env.REACT_APP_WEBSITE === 'SURA' ? (
            <>
              <Typography component="span">
                Ocurrió un error que debemos revisar. Te dejamos los teléfonos
                disponibles por cada gestión disponible:
              </Typography>
              <List component="span">
                <ListItem>
                  <Box mr={1} mb={0} component="span">
                    <FiberManualRecordIcon style={{ width: 15, height: 15 }} />
                  </Box>
                  <Box mr={1} mt={1} component="span">
                    <Typography display="block" component="span">
                      Para reportar un choque, robo o daño hablemos por Whatsapp{' '}
                      <Link
                        color="secondary"
                        href={appConfig?.WHATSAPP_LINK}
                        rel="noopener"
                        target="_blank"
                        onClick={() => logAnalytics(logEvent)}
                      >
                        {appConfig?.FORMATED_WHATSAPP}
                      </Link>{' '}
                      o llamanos al{' '}
                      <Link
                        color="secondary"
                        href={appConfig?.CONTACT_PHONE}
                        rel="noopener"
                        target="_blank"
                        onClick={() => logAnalytics(logEvent)}
                      >
                        {appConfig?.FORMATED_CONTACT_PHONE}
                      </Link>{' '}
                    </Typography>
                  </Box>
                </ListItem>

                <ListItem>
                  <Box mr={1} mb={0} component="span">
                    <FiberManualRecordIcon style={{ width: 15, height: 15 }} />
                  </Box>
                  <Box mr={1} component="span">
                    <Typography display="block" component="span">
                      Para solicitar una asistencia mecánica comunicate al{' '}
                      <Link
                        color="secondary"
                        href={appConfig?.ASSISTANCE_PHONE}
                        rel="noopener"
                        target="_blank"
                        onClick={() => logAnalytics(logEvent)}
                      >
                        {appConfig?.FORMATED_ASSISTANCE_PHONE}
                      </Link>{' '}
                    </Typography>
                  </Box>
                </ListItem>
              </List>
            </>
          ) : (
            <>
              <Typography component="span">
                Te pedimos que cambies tu contraseña para volver a ingresar a la
                App. Si el problema continúa, contactanos de lunes a viernes de
                9 a 18h a alguna de las siguientes opciones:
              </Typography>
              <Typography>
                Whatsapp:{' '}
                <Link
                  color="secondary"
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  {appConfig?.FORMATED_WHATSAPP}
                </Link>
                ,
              </Typography>
              <Typography>
                Central telefónica:{' '}
                <Link
                  color="secondary"
                  href={appConfig?.FORMATED_CONTACT_PHONE}
                  rel="noopener"
                  target="_blank"
                >
                  {appConfig.FORMATED_CONTACT_PHONE}
                </Link>
                ,
              </Typography>
              <Typography>
                Servicio de Grúa y emergencias:{' '}
                <Link
                  color="secondary"
                  href={appConfig?.FORMATED_ASSISTANCE_PHONE}
                  rel="noopener"
                  target="_blank"
                >
                  {appConfig.FORMATED_ASSISTANCE_PHONE}
                </Link>
              </Typography>
            </>
          ),
        action:
          process.env.REACT_APP_WEBSITE === 'SURA' ? (
            <Button color="primary" onClick={onClose}>
              Entendido
            </Button>
          ) : (
            <Grid container justify="center">
              <Grid item>
                <Button onClick={onClose} variant="contained" color="primary">
                  Entendido
                </Button>
              </Grid>
            </Grid>
          ),
      };
  }
};
